import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@clerk/clerk-react';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers';
import type { ResolvedMediaControlSettings } from '@/types/playout/media-control-settings.types';

export const GET_FLOW_MEDIA_CONTROL_SETTINGS_QUERY_KEY = 'flow-media-control';

export function useGetFlowMediaControlSettingsQuery(flowId?: string, options?: { enabled?: boolean }) {
  const { getToken } = useAuth();
  return useQuery({
    queryKey: [GET_FLOW_MEDIA_CONTROL_SETTINGS_QUERY_KEY, flowId],
    queryFn: async () => {
      const token = await getToken();
      const url = `${import.meta.env.VITE_API_URL}/flows/${flowId}/playout/media-control`;
      return sendJSONRequest({ url, method: METHOD.GET, token: token ?? '' }) as Promise<ResolvedMediaControlSettings>;
    },
    enabled: !!flowId && (options?.enabled ?? true),
  });
}
